import { render } from "./ProposalWarnMessage.vue?vue&type=template&id=0a84d990&scoped=true"
import script from "./ProposalWarnMessage.vue?vue&type=script&lang=js"
export * from "./ProposalWarnMessage.vue?vue&type=script&lang=js"

import "./ProposalWarnMessage.vue?vue&type=style&index=0&id=0a84d990&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a84d990"]])

export default __exports__